import { render, staticRenderFns } from "./ApayAgreement.vue?vue&type=template&id=65a0bd3e&scoped=true&"
import script from "./ApayAgreement.vue?vue&type=script&lang=js&"
export * from "./ApayAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a0bd3e",
  null
  
)

export default component.exports